import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const notification = (state: RootState) => state.notifications || initialState;

const selectSlice = (state: RootState) => state.app || initialState;

export const selectApp = createSelector([selectSlice], state => state);

export const selectNotifications = createSelector(
  [notification],
  state => state,
);

export const selectIsLoading = createSelector(
  [selectApp],
  state => state.loading,
);

export const selectIsSuccess = createSelector(
  [selectApp],
  state => state.success,
);

/**
 * NOTE: used for check isLogged is undefined or not (undefined mean we won't do anything until we get by true or false)
 */
export const selectIsLoggedNotEqualUndefined = createSelector(
  [selectApp],
  state => state.isLogged !== undefined,
);

export const selectIsLogged = createSelector([selectApp], state =>
  state.isLogged === undefined ? false : state.isLogged,
);

export const selectLanguage = createSelector(
  [selectApp],
  state => state.language,
);

export const selectAuthDialogInfo = createSelector(
  [selectApp],
  state => state.authDialogInfo,
);

export const selectIsShowDialogLogin = createSelector(
  [selectApp],
  state => state.isShowDialogLogin,
);

export const selectIsShowDialogRegister = createSelector(
  [selectApp],
  state => state.isShowDialogRegister,
);

export const selectTranslations = createSelector(
  [selectApp],
  state => state.translations,
);

export const selectLayout = createSelector([selectApp], state => state.layout);

export const selectLayoutHeader = createSelector(
  [selectLayout],
  layout => layout?.header,
);

export const selectDOMRect = createSelector(
  [selectApp],
  state => state.DOMRect,
);

export const selectLayoutFooter = createSelector(
  [selectLayout],
  layout => layout?.footer,
);

export const selectLayoutCodeConfig = createSelector(
  [selectLayout],
  layout => layout?.codeConfig,
);

export const selectInfoUser = createSelector(
  [selectApp],
  state => state.infoUser,
);

export const selectNational = createSelector(
  [selectApp],
  state => state.national,
);

export const selectProvince = createSelector(
  [selectApp],
  state => state.province,
);

export const selectDistrict = createSelector(
  [selectApp],
  state => state.district,
);

export const selectIsError = createSelector([selectApp], state => state.error);

export const selectIsShowDialogForgotPass = createSelector(
  [selectApp],
  state => state.isShowDialogForgotPass,
);

export const selectIsShowDialogChangePass = createSelector(
  [selectApp],
  state => state.isShowDialogChangePass,
);

export const selectDialogNotiState = createSelector(
  [selectApp],
  state => state.dialogNotiState,
);

export const selectBusinessPartner = createSelector(
  [selectApp],
  state => state.businessPartner.info,
);

export const selectAccListBelongAgent = createSelector(
  [selectApp],
  state => state.businessPartner.accountList,
);

export const selectBusinessPartnerBanlce = createSelector(
  [selectApp],
  state => state.businessPartner.banlce,
);

export const selectMaintenance = createSelector(
  [selectApp],
  state => state.maintenance,
);
